import {
  getCustomerOrders,
  getStatusCodes,
  getCustomerOrderStatus,
  getSavedSearches,
  getClients,
  saveSearch,
} from '../../../api/divvy-customerOrders';

const customerOrders = {
  namespaced: true,
  state: () => ({
    customerOrders: {},
    statusCodes: [],
    orderStatus: [],
    savedSearches: [],
    clients: [],
    form: {
      startdate: '',
      billingcode: '',
      clientids: [],
      enddate: '',
      firstname: '',
      invoicenumber: '',
      isgift: false,
      lastname: '',
      ordernumbers: [],
      orderstatuscodes: [],
      supplierids: [],
      statuscodes: [],
      trackingnumber: '',
      username: '',
      userorderid: null,
      platform: '',
      pageNumber: 1,
      pageSize: 10,
      sortField: 'ORDERDATE',
      sortOrder: 'DESC',
      searchlimit: '50',
    },
    filters: {
      list: '',
      islist: false,
      sDate: '',
      eDate: '',
    },
  }),
  getters: {
    allCustomerOrders: (state) => state.customerOrders,
    allStatusCodes: (state) => state.statusCodes,
    allOrderStatus: (state) => state.orderStatus,
    allSavedSearches: (state) => state.savedSearches,
    allClients: (state) => state.clients,
    customerForm: (state) => state.form,
  },
  actions: {
    fetchCustomerOrders({ commit }, data) {
      console.log(data, 'from fetchCustomerOrders');
      commit('SET_CUSTOMER_FORM', data);
      return new Promise((resolve, reject) => {
        getCustomerOrders(data)
          .then((resp) => {
            commit('SET_CUSTOMER_ORDERS', resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, ' error from fetchCustomerOrders');
          });
      });
    },
    fetchStatusCodes({ commit }) {
      return new Promise((resolve, reject) => {
        getStatusCodes()
          .then((resp) => {
            commit('SET_STATUS_CODES', resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, 'from getStatusCodes');
          });
      });
    },
    fetchCustomerOrderStatus({ commit }) {
      return new Promise((resolve, reject) => {
        getCustomerOrderStatus()
          .then((resp) => {
            commit('SET_ORDER_STATUS', resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, 'from getCustomerOrderStatus');
          });
      });
    },

    fetchSavedSearches({ commit }) {
      return new Promise((resolve, reject) => {
        getSavedSearches()
          .then((resp) => {
            commit('SET_SAVED_SEARCHES', resp.data);
            resolve(resp.data);
          })
          .catch((err) => {
            console.log(err, 'from getSavedSearches');
          });
      });
    },

    getClients({ state, commit }) {
      return new Promise((resolve, reject) => {
        getClients()
          .then((resp) => {
            console.log(resp, 'from getAllClients');
            state.clients = resp;
            resolve(resp);
          })
          .catch((err) => {
            console.log(err, 'from getAllSuppliers');
          });
      });
    },

    saveSearch({}, payload) {
      return new Promise((resolve, reject) => {
        saveSearch(payload)
          .then(() => {
            resolve();
          })
          .catch((err) => {
            console.log(err, 'from saveSearch');
          });
      });
    },
  },
  mutations: {
    SET_CUSTOMER_ORDERS(state, data) {
      state.customerOrders = data;
    },
    SET_STATUS_CODES(state, data) {
      state.statusCodes = data;
    },
    SET_ORDER_STATUS(state, data) {
      state.orderStatus = data;
    },
    SET_SAVED_SEARCHES(state, data) {
      state.savedSearches = data;
    },
    SET_CUSTOMER_FORM(state, data) {
      state.form = data;
    },
  },
};

export default customerOrders;
